module.exports = __webpack_public_path__ + "linea-basic-elaboration-10.3759629be32bb8b55b21.ttf";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/sm8-v1-front/src/scss/icons/linea-icons/fonts/linea-basic-elaboration-10.ttf
// module id = ../../../../../src/scss/icons/linea-icons/fonts/linea-basic-elaboration-10.ttf
// module chunks = styles